export default [/\/metrics\/.*\.js/i, /pinterest\.com/i];
